import React from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import Awards from "../AboutUs/Awards";

const HonorsInspire = ({ data }) => {
    const fallbackAwards = [
        {
          url: "/png/award1.png",
          alternativeText: "Excellence Award 2024",
          id: 1
        },
        {
          url: "/png/award2.png", 
          alternativeText: "Innovation Award 2023",
          id: 2
        },
        {
          url: "/png/award3.png",
          alternativeText: "Quality Recognition 2023", 
          id: 3
        },
        {
          url: "/png/award4.png",
          alternativeText: "Industry Leadership Award 2022",
          id: 4
        },
        {
          url: "/png/award5.png",
          alternativeText: "Customer Choice Award 2022",
          id: 5
        },
        {
          url: "/png/award6.png",
          alternativeText: "Best Newcomer Award 2021",
          id: 6
        }
      ];
return (
    <Box py={{ base: "60px", md: "80px" }} px={{ base: 4, md: 8 }}>
        <Container maxW="auto" px={{ base: 4, md: 8 }}>
            <VStack spacing={6} align="center">
                <VStack spacing={1} align="center" w="full">
                    <Text
                        fontSize={{ base: "lg", md: "3xl" }}
                        color="gray.600"
                        lineHeight="tall"
                        fontWeight="bold"
                        textAlign={"justify"}
                        mb={0}
                    >
                        {data?.awardSection?.title}
                    </Text>
                    <Text
                        fontStyle="italic"
                        color="gray.500"
                        fontSize={{ base: "md", md: "lg" }}
                        fontWeight="normal"
                        py={0}
                        mt={0}
                        mb={0}
                    >
                        Recognition for Innovation, Trust, and Impact
                    </Text>
                </VStack>

                <Text
                    fontSize={{ base: "sm", md: "md" }}
                    color="gray.600"
                    fontWeight="normal"
                    mt={4}
                    maxW="1200px"
                    textAlign="justify"
                >
                    At Business Automation Limited, every accolade is more than an
                    award—it's a recognition of the passion, precision, and purpose that
                    define our work. These honors affirm our long-standing commitment to
                    delivering technology solutions that truly matter. Over the years,
                    our projects have been nationally and internationally acclaimed for
                    their innovation, impact, and excellence in transforming public
                    services, digital governance, and enterprise operations.
                </Text>

                <Text
                    fontSize={{ base: "sm", md: "md" }}
                    color="gray.600"
                    textAlign="justify"
                ></Text>

                <Awards fallbackAwards={fallbackAwards} />
                <Text
                    fontSize={{ base: "sm", md: "md" }}
                    color="gray.600"
                    textAlign="justify"
                >
                    These achievements reflect the trust of our clients, the strength of
                    our partnerships, and the dedication of our people—who turn vision
                    into impact every single day.
                </Text>
            </VStack>
        </Container>
    </Box>
);
};

export default HonorsInspire;
